/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/* ----------------------------------------------
Import and assign modules as global variables
---------------------------------------------- */

import * as Meteora from 'meteora';
// import Classy from '@meteora-digital/classy';
import ModalController from '@meteora-digital/modal';
import TweenController from '@meteora-digital/tween';
import { tns } from "tiny-slider/src/tiny-slider";
import DecisionTreeController from 'scripts/marmalade/classes/decision-tree';
// import Watcher from 'scripts/marmalade/classes/watcher';

window.Meteora = Meteora;
// window.Classy = Classy;
window.TweenController = TweenController;
window.ModalController = ModalController;
window.tns = tns;
window.DecisionTreeController = DecisionTreeController;
// window.Watcher = Watcher;

/*------------------------------------------------------------------
Add conditional scripts to the ScriptLoader object below
------------------------------------------------------------------*/

// document.addEventListener('DOMContentLoaded', () => {

// Add the src and a condition required to load the script
window.CriticalLoader = ScriptLoader({
  './components/global': true,
  // New header
  './elements/menu': document.querySelector('.js-menu'),
  './components/breakpoints': document.querySelector('[data-breakpoint]'),
  // './components/equalizer': document.querySelector('[data-equalize-watch]'),
  // './components/selectors': document.querySelector('select'),

  './elements/banner': document.querySelector('.js-banner'),
  './product-finder/index': document.querySelector('.js-product-finder'),
  './triage-form/index': document.querySelector('.js-triage-form'),
  './components/google-recaptcha': document.querySelector('form'),
  './pages/research-papers': document.querySelector('.js-research-papers'),
  './pages/people': document.querySelector('.js-people-holder'),
  './pages/events': document.querySelector('.js-events-holder'),
  './pages/blog': document.querySelector('.js-blog-page'),
  './pages/grants': document.querySelector('.js-grant-recipients'),
  './pages/partners': document.querySelector('.js-partners'),
  './pages/documents': document.querySelector('.js-documents'),
  './pages/top-companies-holder': document.querySelector('.js-top-companies'),
  './pages/up-and-coming': document.querySelector('.js-up-and-coming'),
  './pages/video-resources': document.querySelector('.js-video-resources'),
  './pages/product-contact-page': document.querySelector('.js-product-contact-page'),
  './pages/resources': document.querySelector('.js-resources')
}, 'critical-loaded');

// });

window.addEventListener('critical-loaded', () => {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
  window.ScrollLocker.unlock();
  window.scrollTo(0, 0);
  window.ScriptLoader = ScriptLoader({
    './components/parallax': document.querySelector('[data-parallax]'),
    // Old header
    './elements/header': document.querySelector('.js-header'),
    // Old mobile menu
    './elements/mobile-menu': document.querySelector('.js-mobile-menu'),
    // New mobile menu
    './elements/menu-mobile': document.querySelector('.js-menu-mobile'),
    // Old menu
    './elements/mega-menu': document.querySelector('.js-mega-menu'),
    // New menu
    './elements/menu-mega': document.querySelector('.js-menu-mega'),
    './elements/search': document.querySelector('.js-search'),
    './elements/blocks-navigation': document.querySelector('.js-blocks-navigation'),
    './components/language-toggle': document.querySelector('.js-language-toggle'),
    './components/page-scroll-progress': document.querySelector('.js-page-scroll-progress'),
    './components/limit-text': document.querySelector('[data-limit]'),
    './components/limit-characters': document.querySelector('form'),
    './elements/video-modals': document.querySelector('[data-video-modal]'),
    './elements/forms': document.querySelector('form.userform, .js-form form'),
    './elements/article-navigation': document.querySelector('.js-article-navigation')
    // './pages/product-page': document.querySelector('[data-classname="ProductPage"]'),
  });
});

// window.addEventListener('scripts-loaded', () => {
//   window.equalize();
// });

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader() {
  let imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let evt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scripts-loaded';
  // An array of the import object keys
  const scripts = Object.keys(imports).filter(key => imports[key]);
  // For debugging purposes only
  const components = [];
  Promise.all(scripts.map(script => import(`${script}`).then(() => components.push(script)).catch(error => console.warn(error)))).then(() => setTimeout(() => window.dispatchEvent(new Event(evt)), 500));
  return components;
}